<template>
    <div class="occupation-public">
        <OccupationIntermentItem
            class="interment"
            v-for="(interment, idx) in interments"
            :key="`interment-${idx}`"
            :value="interment"
            :indexItem="idx"
            :panelCfg="panelCfg"
            :moduleCode="moduleCode"
            :baseTranslateID="baseTranslateID"
        />
    </div>
</template>

<script>
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";

export default {
    mixins: [
        CemeteryElementMixin
    ],
    components: {
        OccupationIntermentItem: () => import(/* webpackChunkName: "cemeteries-occupationintermentitem" */ './OccupationIntermentItem'),
    },
    props: {
    },
    data() {
        return {

        }
    },
    computed: {
        interments() {
            return this.value?.interments ?? [];
        }
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.occupation-public {
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    gap: 16px;
}
</style>